import axios from "axios";

export const state = {
    discharges: [],
};

export const getters = {
    discharges: state => state.discharges,
};

export const mutations = {
    setDischarges(state, newValue) {
        state.discharges = newValue
    },
};

export const actions = {
    fetchDischarges({ commit }) {
        axios.get('/patientdischarges').then(res => {
            commit('setDischarges', res.data.discharges);
        })
    },
};